<template>
  <el-container class="zbody">
    <el-aside :width="asdewidth" :class="{left57:viewwidth<900 && shrinks==1}">
      <el-row class="saide-top">
        开能禅
        <span v-if="!isCollapse">后台</span>
      </el-row>
      <el-menu default-active="user" class="el-menu-vertical-demo" unique-opened router :collapse-transition="false"
        :collapse="isCollapse" @open="handleOpen" @close="handleClose">
        <!--        v-if="havepermission('1')"-->
        <el-submenu index="user" v-if="havepermission('1')">
          <template slot="title">
            <img src="../assets/yhgl.png" alt="">
            <!--            <i class="iconfont icon-yinpin"></i>-->
            <span>用户管理</span>
          </template>
          <el-menu-item index="user">用户管理</el-menu-item>
          <el-menu-item index="vipList">渠道会员列表</el-menu-item>
          <el-menu-item index="exchangeCode">生成会员兑换码</el-menu-item>
          <el-menu-item index="infoPush">消息推送</el-menu-item>
          <!-- <el-menu-item index="gzh">公众号回复</el-menu-item> -->
        </el-submenu>
        <el-menu-item index="headImg" v-if="havepermission('2')">
          <img src="../assets/txpp.png" alt="">
          <span slot="title">头像匹配</span>
        </el-menu-item>
        <!--       <el-menu-item index="article" >-->
        <!--         <img src="../assets/txdz.png" alt="">-->
        <!--          <span slot="title">头像定制</span>-->
        <!--        </el-menu-item>-->
        <!--       <el-menu-item index="touImg">-->
        <!--         <img src="../assets/mzdz.png" alt="">-->
        <!--          <span slot="title">名字定制</span>-->
        <!--        </el-menu-item>-->
        <!--        <el-menu-item index="master" >-->
        <!--          <img src="../assets/yyfw.png" alt="">-->
        <!--          <span slot="title">预约服务</span>-->
        <!--        </el-menu-item>-->
        <!--        <el-menu-item index="videotheme">-->
        <!--          <img src="../assets/spgl.png" alt="">-->
        <!--          <span slot="title">视频管理</span>-->
        <!--        </el-menu-item>-->
        <el-submenu index="videotheme" v-if="havepermission('3')">
          <template slot="title">
            <img src="../assets/spgl.png" alt="">
            <span>视频管理</span>
          </template>
          <el-menu-item index="videotheme">短视频</el-menu-item>
          <el-menu-item index="videos">课程</el-menu-item>
        </el-submenu>
        <el-menu-item index="orderListH5" v-if="havepermission('4')">
          <img src="../assets/ddgl.png" alt="">
          <span slot="title">订单管理</span>
        </el-menu-item>
        <!--        <el-submenu  index="7">-->
        <!--          <template slot="title">-->
        <!--            <img src="../assets/ddgl.png" alt="">-->
        <!--            <span>订单管理</span>-->
        <!--          </template>-->
        <!--          <el-menu-item index="orderListH5">网页订单列表</el-menu-item>-->
        <!--          <el-menu-item index="orderListApp">APP订单列表</el-menu-item>-->
        <!--        </el-submenu>-->
        <el-submenu index="finance" v-if="havepermission('5')">
          <template slot="title">
            <img src="../assets/cwsj.png" alt="">
            <span>财务数据</span>
          </template>
          <el-menu-item index="finance">提现</el-menu-item>
          <el-menu-item index="financeCommissionSet">提成比例设置</el-menu-item>

          <el-menu-item index="financeAmount">统计</el-menu-item>
        </el-submenu>
        <el-submenu index="partner" v-if="havepermission('6')">
          <template slot="title">
            <img src="../assets/gdsz.png" alt="">
            <span>股东与分红</span>
          </template>
          <el-menu-item index="partner">股东管理</el-menu-item>
          <!--          <el-menu-item index="returns">退款分红扣回</el-menu-item>-->
          <el-menu-item index="bonus">分红记录</el-menu-item>
        </el-submenu>

        <el-menu-item index="admin" v-if="userdata.issuperadmin==1">
          <img src="../assets/glygl.png" alt="">
          <span slot="title">管理员管理</span>
        </el-menu-item>
        <el-submenu index="Gzh" v-if="havepermission('1')">
          <template slot="title">
            <img src="../assets/gzh.png" style="width: 15px; height: 16px;" alt="">
            <span>和老师聊聊</span>
          </template>
          <el-menu-item index="Gzh">消息列表</el-menu-item>
          <el-menu-item index="Dzhf">定制回复</el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
    <el-container class="index-right">
      <div class="msk" v-if="viewwidth<900 && shrinks==2" @click="shrink"></div>
      <el-header :height="headheight">
        <el-row>
          <el-col :span="12" style="text-align: left;">
            <i class="iconfont icon-aside-shrink" style="font-size: 20px;cursor: pointer" v-if="!isCollapse"
              @click="shrink"></i>
            <i class="iconfont icon-aside-unfold" style="font-size: 20px;cursor: pointer" v-if="isCollapse"
              @click="unfold"></i>
          </el-col>
          <el-col :span="12">
            <el-dropdown style="color: #333">
              <span class="el-dropdown-link">
                {{ userdata.user_name }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="xiugaimimaVisible = true">修改密码</el-dropdown-item>
                <el-dropdown-item style="color: #333" divided @click.native="adminlogout()">退出
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </el-row>
      </el-header>
      <el-main>
        <!--<keep-alive>-->
        <router-view></router-view>
        <!--</keep-alive>-->
      </el-main>
    </el-container>
    <el-dialog :visible.sync="xiugaimimaVisible" title="修改密码" width="300px" :modal-append-to-body="false">
      <el-form :model="editform">
        <el-form-item label="新密码" :label-width="formLabelWidth">
          <el-input v-model="editform.user_password" auto-complete="off" placeholder="请输入新密码" required></el-input>
        </el-form-item>
        <el-form-item label="确认密码" :label-width="formLabelWidth">
          <el-input v-model="editform.againuser_password" auto-complete="off" placeholder="请再次输入输入新密码" required>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="xiugaimimaVisible = false">取 消</el-button>
        <el-button type="primary" @click="reAdminSubmit()"
          :disabled="editform.user_password=='' || editform.againuser_password==''">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
  export default {
    name: "Index",
    mounted() {
      // this.getstart()
      this.meddd()
    },
    data() {
      return {
        dataa: [],
        fullscreenLoading: false,
        isCollapse: false,
        viewwidth: document.body.clientWidth,
        asdewidth: '221px',
        headheight: '56px',
        shrinks: 2,
        xiugaimimaVisible: false,
        editform: {
          user_id: '',
          user_password: '',
          againuser_password: ''
        },
        formLabelWidth: '80px'
      }
    },
    computed: {
      userdata() {
        return this.$store.state.login.user
      },
      permissiondata() {

      }
    },
    watch: {},
    methods: {
      adminlogout() {
        this.$store.commit('logout');
        this.$router.push({
          name: 'login'
        })
      },
      getstart() {
        // if (!this.$store.state.login.in) {
        //   this.$router.push({name: "login", params: {userId: 123}})
        // }
        // console.log(this.userdata.permission)
      },
      handleOpen(key, keyPath) {
        // console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        // console.log(key, keyPath)ka223s;
      },
      meddd() {
        if (this.viewwidth < 900) {
          this.isCollapse = true
          this.asdewidth = '57px'
          this.headheight = '50px'
          this.shrinks = 1
        }
      },
      shrink() {
        this.isCollapse = true
        this.asdewidth = '57px'
        this.shrinks = 1
      },
      unfold() {
        this.isCollapse = false
        this.asdewidth = '221px'
        this.shrinks = 2
      },
      // 权限，后台返回permission
      havepermission(index) {
        console.log(index, 'permissiondata')
        if (this.userdata.permission) {
          var permissiondata = this.userdata.permission.split(",");
          var ind = permissiondata.indexOf(index)
          if (ind >= 0) {
            return true
          } else {
            return false
          }
        }
        return false
      },
      // issuperadmin() {
      //   if (this.userdata.issuperadmin) {
      //     if (this.userdata.issuperadmin == 1) {
      //       return true
      //     } else {
      //       return false
      //     }
      //   }
      //   return false
      // },
      reAdminSubmit() {
        let thi = this
        thi.fullscreenLoading = true
        thi.editform.user_id = thi.userdata.user_id
        console.log(thi.userdata)
        thi.$http.post(global.posturl.host + global.posturl.changePwdOfSelf,
          thi.editform
        ).then(function(response) {
          var qcode = response.data.code
          var qmsg = response.data.msg
          var qdata = response.data.data
          thi.fullscreenLoading = false
          if (qcode == 200) {
            thi.$store.commit('logout')
            thi.$router.push({
              name: "login",
              params: {
                userId: 123
              }
            })
            thi.$message({
              message: '修改成功,请重新登录!',
              type: 'success',
              duration: 5000
            });
            thi.fullscreenLoading = false
            thi.xiugaimimaVisible = false
          } else {
            thi.$message({
              message: qmsg,
              type: 'error',
              duration: 5000
            });
          }

        }).catch(function(error) {
          console.log(error)
        });
      }
    }
  }
</script>

<style scoped>
  @media (max-width: 900px) {
    .el-aside {
      background-color: #fff;
      color: #D2D2D4;
      text-align: center;
      border-right: solid 1px #e5e5e5;
      width: 55px;
      overflow-x: hidden;
    }

    .el-header {
      line-height: 56px;
    }

    .el-main {
      padding: 0px;
    }
  }

  @media (min-width: 900px) {
    .el-aside {
      background-color: #fff;
      color: #D2D2D4;
      text-align: center;
      border-right: solid 1px #e5e5e5;
      overflow-x: hidden;
    }

    .el-header {
      line-height: 56px;
    }
  }

  .el-aside {
    transition: all 0.4s;
  }

  .el-header {
    text-align: right;
    font-size: 14px;
    background-color: #fff;
    color: #333;
    border-bottom: solid 1px #EDEDED;
  }

  .zbody {
    position: fixed;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .el-menu-vertical-demo {
    /*width: 220px;*/
    text-align: left;
    overflow: hidden;
    z-index: 19;
    border: none;
  }

  .index-right {
    overflow: auto;
  }

  .el-main {
    background-color: #F2F2F2;
    color: #333;
    text-align: center;
    overflow: auto;
    padding: 0px;
  }

  .saide-top {
    height: 56px;
    text-align: center;
    line-height: 56px;
    background-color: #fff;
    color: black;
  }

  .left57 {
    margin-left: -57px;
  }

  .msk {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: black;
    z-index: 999;
    opacity: 0.1;
  }
</style>



// WEBPACK FOOTER //
// src/page/Index.vue